import {EnkelGruppeModell, GruppeId, GruppeInvitasjonSpesifikasjoner, GruppeMedlemListeModell, GruppeModell, GruppeRessursClient, MedlemsRolleModell, MøteRessursClient} from "../../../../../../felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {AbstractControl, FormControl, ReactiveFormsModule} from "@angular/forms";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogContent, MatDialogRef} from "@angular/material/dialog";
import {AfterViewInit, ChangeDetectionStrategy, Component, computed, Inject, Injectable, Signal, signal, ViewChild} from "@angular/core";
import {MatButton, MatIconButton} from "@angular/material/button";
import {MatIcon} from "@angular/material/icon";
import {MatToolbar} from "@angular/material/toolbar";
import {VisSpinnerDirektiv} from "web-ng2/delt/direktiver/button--visSpinner/button--visSpinner";
import {TranslateModule} from "@ngx-translate/core";
import {MatButtonToggle, MatButtonToggleGroup} from "@angular/material/button-toggle";
import {MedlemImporterFraGruppeKomponent} from "../../komponenter/medlem-importer-fra-gruppe/medlem-importer-fra-gruppe";
import {MedlemImporterFraRegnearkKomponent} from "../../komponenter/medlem-importer-fra-regneark/medlem-importer-fra-regneark";
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";
import {Observable} from "rxjs";
import {MedlemImporterSkjemalinjeKomponentAvhengigheter, MedlemImporterSkjemalinjeKomponentAvhengigheter_DI_TOKEN} from "web-ng2/moduler/medlem/importer-medlemmer/komponenter/medlem-importer-skjemalinje/medlem-importer-skjemalinje";
import {MatSlideToggle} from "@angular/material/slide-toggle";
import {MatTooltip} from "@angular/material/tooltip";
import {MeldingTilBruker} from "felles/tjenester/MeldingTilBruker";
import {i18n, Oversettelser} from "felles-ng2/tjenester/i18n/Oversettelser";
import {GruppemedlemDatatjeneste} from "felles-ng2/tjenester/datalager/GruppemedlemDatatjeneste";
import {eksistererMedlemMedEpost, eksistererMedlemMedNavn, medlemmerIkkeAnonymisert, ValiderEpostRespons} from "felles-ng2/modell/medlemModellHjelpere";
import {lagrerSignal} from "felles-ng2/tjenester/LagrerIndikator";

export type MedlemImporterDialogRespons = GruppeModell | null;
const debug = initDebugger('MedlemImporterDialogKomponent');


@Component({
    selector: 'kopier-moete-dialog',
    templateUrl: 'medlem-importer-dialog.html',
    styleUrls: ['medlem-importer-dialog.scss'],
    providers: [{ provide: MedlemImporterSkjemalinjeKomponentAvhengigheter_DI_TOKEN, useExisting: MedlemImporterDialogKomponent }],
    imports: [
        MatTooltip,
        MatToolbar,
        MatIcon,
        MatButtonToggleGroup,
        MatButtonToggle,
        MatDialogContent,
        MatDialogActions,
        MatSlideToggle,
        MatButton,
        MatIconButton,
        ReactiveFormsModule,
        TranslateModule,
        MedlemImporterFraRegnearkKomponent,
        MedlemImporterFraGruppeKomponent,
        VisSpinnerDirektiv
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MedlemImporterDialogKomponent implements AfterViewInit, MedlemImporterSkjemalinjeKomponentAvhengigheter {

    static vis(dialog: MatDialog, gruppe: EnkelGruppeModell): MatDialogRef<MedlemImporterDialogKomponent, MedlemImporterDialogRespons> {
        return dialog.open(MedlemImporterDialogKomponent, {data: {gruppe} as DialogParametre, disableClose: true, ariaLabelledBy: 'medlem-importer-dialog-tittel', minHeight: 600, width: '90%', maxWidth: '1700px'});
    }

    @ViewChild(MedlemImporterFraGruppeKomponent) medlemImporterFraGruppe!: MedlemImporterFraGruppeKomponent;
    @ViewChild(MedlemImporterFraRegnearkKomponent) medlemImporterFraRegneark!: MedlemImporterFraRegnearkKomponent;

    gruppe!: EnkelGruppeModell;
    importType = new FormControl<'regneark' | 'gruppe'>('gruppe');
    sendInvitasjon = new FormControl(true, {nonNullable: true});
    sendInnkallingTilMoeter = new FormControl(true, {nonNullable: true});

    medlemsroller = signal<MedlemsRolleModell[]>([]); //initialiseres i set gruppe
    aktivKontroller = signal<MedlemImporterSkjema | null>(null);
    antallLinjerValgt = computed(() => this.aktivKontroller()?.antallValgt() || 0);
    lagrer = lagrerSignal();
    antallMoeterDetSkalSendesInnkallingTilMoeter = signal(0);

    private alleMedlemmer: GruppeMedlemListeModell[] = [];

    constructor(@Inject(MAT_DIALOG_DATA) parametre: DialogParametre,
                private avhengigheter: MedlemImporterDialogKomponentAvhengigheter,
                private meldingTilBruker: MeldingTilBruker,
                private oversettelser: Oversettelser,
                public dialogRef: MatDialogRef<MedlemImporterDialogKomponent, MedlemImporterDialogRespons>) {
        this.gruppe = parametre.gruppe;
        this.avhengigheter.medlemsroller(this.gruppe.id)
          .subscribe(roller => this.medlemsroller.set(roller));
        this.importType.valueChanges.pipe(takeUntilDestroyed())
          .subscribe(aktiv => this.setAktivKontroller());
        this.avhengigheter.medlemmer(this.gruppe.id).pipe(takeUntilDestroyed())
          .subscribe(medlemmer => this.alleMedlemmer = medlemmer);

        this.avhengigheter.finnIkkeAvholdteMøterSomNyeMedlemmmerKanLeggesTil(this.gruppe.id).then(
          antall => {
              this.antallMoeterDetSkalSendesInnkallingTilMoeter.set(antall);
              antall > 0 ? this.sendInnkallingTilMoeter.enable() : this.sendInnkallingTilMoeter.disable();
          }
        );

    }

    avbryt() {
        this.dialogRef.close(null);
    }

    async importer() {
        const spesifikasjon = this.aktivKontroller()!.somSpesifikasjon();
        spesifikasjon.invitasjoner.forEach(invitasjon => {
            invitasjon.sendInvitasjon = this.sendInvitasjon.value;
            invitasjon.sendInnkallingTilMoeter = this.sendInnkallingTilMoeter.value;
        });

        await this.lagrer.utfør(async () => {
            const oppdatertGruppe = await this.avhengigheter.importer(spesifikasjon);
            if (this.sendInvitasjon.value)
                this.meldingTilBruker.infomelding(this.oversettelser.oversett(i18n('Invitasjon sendt til {antall} nye medlemmer'), {antall: spesifikasjon.invitasjoner.length}));
            else
                this.meldingTilBruker.infomelding(this.oversettelser.oversett(i18n('{antall} nye invitasjoner registrert'), {antall: spesifikasjon.invitasjoner.length}));
            this.dialogRef.close(oppdatertGruppe);
        });
    }

    ngAfterViewInit(): void {
        this.setAktivKontroller();
    }

    //MedlemImporterSkjemalinjeKomponentAvhengigheter implementasjon

    verifiserAtEpostIkkeAlleredeErRegistrert(epost: string): ValiderEpostRespons {
        return eksistererMedlemMedEpost(this.alleMedlemmer, epost);
    }

    /** Sann dersom det ikke finnes et medlem med samme navn (casing ignorert), ignorer permanent deaktiverte medlemmer */
    verifiserAtNavnIkkeAlleredeErRegistrert(navn: string): boolean {
        return eksistererMedlemMedNavn(medlemmerIkkeAnonymisert(this.alleMedlemmer), navn);
    }

    //hjelpemetoder

    private setAktivKontroller() {
        this.aktivKontroller.set(this.importType.value == 'regneark' ? this.medlemImporterFraRegneark : this.medlemImporterFraGruppe);
    }

}

export interface DialogParametre {
    gruppe: GruppeModell;
}

@Injectable()
export class MedlemImporterDialogKomponentAvhengigheter {

    constructor(private gruppeRessurs: GruppeRessursClient, private gruppemedlemDatatjeneste: GruppemedlemDatatjeneste, private møteRessurs: MøteRessursClient) {
    }

    /** Returnerer tilgjengelige medlemsroller */
    medlemsroller(gruppeId: GruppeId): Observable<MedlemsRolleModell[]> {
        return this.gruppeRessurs.finnTilgjengeligeRoller(gruppeId).somObservable();
    }

    /** Returnerer alle medlemmer tilknyttet gruppen */
    medlemmer(gruppeId: GruppeId): Observable<GruppeMedlemListeModell[]> {
        return this.gruppemedlemDatatjeneste.finnTilknyttet(gruppeId);
    }

    importer(spesifikasjon: GruppeInvitasjonSpesifikasjoner): Promise<GruppeModell> {
        return this.gruppemedlemDatatjeneste.inviterNyeMedlemmer(spesifikasjon);
    }

    async finnIkkeAvholdteMøterSomNyeMedlemmmerKanLeggesTil(gruppeId: GruppeId): Promise<number> {
        const møter = await this.møteRessurs.finnIkkeAvholdteMøterSomNyeMedlemmmerKanLeggesTil({gruppeId:gruppeId}).somPromise();
        return møter.filter(m => m.moeteInnkallingSendt).length;
    }

}

export interface MedlemImporterSkjema {
    skjema: AbstractControl;
    antallValgt: Signal<number>;

    somSpesifikasjon(): GruppeInvitasjonSpesifikasjoner;
}
